module.exports = __webpack_public_path__ + "media/seo/br-94a68805.jpg";